import React, { useState } from "react";
import { netmarbleCouponBatch } from "../api/riotApi";
import './NetmarbleCouponPage.css';

export default function NetmarbleCouponPage() {
  // 기본 PUID 목록은 변수로만 저장
  const defaultPuids = `
F605B10AAC5D493287CB02A2C9705AAE
7009274D588845C39084CC3A73E4FD28
B4F1456483214382825F9F25A67CF7F2
D5A4B945D42F479D9FEDA71B83B78529
0A0755B9D3664F4B80D927EB376A934F
AD25F9C3800F4B64AB903BA655878839
D94CDB8AF18B48C79584F835FF3512CC
51FAC78B3D4E4D12B33DD34207BF8767
0D6F457A44D8487BA0A1EC9B43DFFC58
C411AD2726D445DE9774B85855D4EDAD
411FFDFF20C94C47BEB8A14517997459
66074341B92845B2BD80C0D0785FB731
1318E591312241C7B124B429CE321BAB
D7371408C1034E50959546D6DCD5E6E4
  `.trim();

  // 초기값을 빈 문자열로 변경
  const [puidText, setPuidText] = useState("");
  const [couponText, setCouponText] = useState("");
  const [logs, setLogs] = useState([]);
  const [isRunning, setIsRunning] = useState(false);
  const [progress, setProgress] = useState({ current: 0, total: 0 });

  const parseLines = (text) =>
    text
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

  const appendLog = (line) => setLogs((prev) => [...prev, line]);

  const handleRun = async () => {
    const puids = parseLines(puidText);
    const coupons = parseLines(couponText);

    if (puids.length === 0) {
      alert("PUID를 한 줄에 하나씩 입력해 주세요.");
      return;
    }
    if (coupons.length === 0) {
      alert("쿠폰 코드를 한 줄에 하나씩 입력해 주세요.");
      return;
    }

    // PUID × 쿠폰 전체 조합 생성
    const items = [];
    for (const puid of puids) {
      for (const code of coupons) {
        items.push({ playerId: puid, code });
      }
    }

    const total = items.length;
    if (!window.confirm(`총 ${total}건 (PUID ${puids.length}명 × 쿠폰 ${coupons.length}개)\n드라이버 1회 실행으로 처리합니다. 진행할까요?`)) {
      return;
    }

    setIsRunning(true);
    setLogs([]);
    setProgress({ current: 0, total });

    try {
      const res = await netmarbleCouponBatch(items);
      const results = res.data; // List<RedeemItemResult>

      results.forEach((r, idx) => {
        const item = items[idx];
        appendLog(
          `[${idx + 1}/${total}] PUID=${item.playerId} / 쿠폰=${r.code} → ${r.success ? "성공" : "실패"}${r.message ? ` (${r.message})` : ""}`
        );
      });

      setProgress({ current: total, total });
    } catch (e) {
      const res = e.response;
      if (res?.data) {
        appendLog(`요청 실패 (status=${res.status}) ${JSON.stringify(res.data)}`);
      } else {
        appendLog(`요청 실패: ${e.message}`);
      }
    }

    appendLog("=== 모든 요청이 종료되었습니다. ===");
    setIsRunning(false);
  };

  const handleClear = () => {
    setLogs([]);
    setProgress({ current: 0, total: 0 });
  };

  // "우용지인" 버튼 클릭 시 PUID 입력란에 defaultPuids 입력
  const handleFillDefaultPuids = () => {
    setPuidText(defaultPuids);
  };

  const progressText =
    progress.total > 0 ? `${progress.current} / ${progress.total}` : "대기 중";

  return (
    <div className="coupon-page">
      <h1>넷마블 쿠폰 일괄 등록</h1>

      {/* 추가: 우용지인 버튼 */}
      <div style={{ marginBottom: "16px" }}>
        <button onClick={handleFillDefaultPuids} disabled={isRunning}>
          우용지인
        </button>
      </div>

      <div className="top-row">
        <div className="textbox-wrapper">
          <label className="textbox-label">PUID 목록 (한 줄에 하나씩)</label>
          <textarea
            className="textbox"
            value={puidText}
            onChange={(e) => setPuidText(e.target.value)}
            rows={10}
            disabled={isRunning}
          />
        </div>

        <div className="textbox-wrapper">
          <label className="textbox-label">쿠폰 코드 목록 (한 줄에 하나씩)</label>
          <textarea
            className="textbox"
            value={couponText}
            onChange={(e) => setCouponText(e.target.value)}
            rows={10}
            disabled={isRunning}
          />
        </div>
      </div>

      <div className="controls">
        <button onClick={handleRun} disabled={isRunning}>
          {isRunning ? "등록 중..." : "쿠폰 등록 실행"}
        </button>
        <button onClick={handleClear} disabled={isRunning && logs.length === 0}>
          결과 지우기
        </button>
        <span className="progress">진행 상황: {progressText}</span>
      </div>

      <div className="result-wrapper">
        <label className="textbox-label">쿠폰 등록 결과</label>
        <textarea className="result-textbox" value={logs.join("\n")} readOnly rows={15} />
      </div>
    </div>
  );
}